<template>

  <loading-data-page-container
    :loading="!isInitialized && !loadingError"
    :loading-error="loadingError"
    :loading-error-message="loadingErrorMessage"
    :hint="loadingErrorHint"
    max-width
    class="presse-page">

    <template v-if="isInitialized && !loadingError">

      <product-info-block :sections="AboutPresse.sections"
                          title="Presse"
                          class="presse-product-info-block" />

    </template>

  </loading-data-page-container>

</template>

<script>

import ProductInfoBlock from "@/components/productInfo/ProductInfoBlock";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";

export default {
  name: "PressePage",
  components: { LoadingDataPageContainer, ProductInfoBlock },
  mixins: [contentLoadingMixin(["AboutPresse"])]
};
</script>
